module.exports = __webpack_public_path__ + "img/family-tolcser.fd6d3baa.png";